import { withRouter } from 'react-router';
import { VideoPlayer } from 'dma-ui-kit';
import styled from 'styled-components';

const Container = styled.div`
    margin-bottom: 20px;
`;

const VideoHeroWidget = (props) => {
    const { field_desktop_video, field_mobile_video, field_tablet_video } = props.paragraph.relationships;

    const autoPlay = (props.paragraph.attributes.field_behavior == 'autoplay_muted' || props.paragraph.attributes.field_behavior == 'autoplay_with_audio') ? true : false;
    const muted = (props.paragraph.attributes.field_behavior == 'autoplay_muted') ? true : false; 

    const desktop_media = field_desktop_video.data.relationships.field_media_video_file.data.attributes.uri.url;
    const tablet_media = field_tablet_video.data.relationships.field_media_video_file.data.attributes.uri.url;
    const mobile_media = field_mobile_video.data.relationships.field_media_video_file.data.attributes.uri.url;

    return (
        <Container>
            <VideoPlayer
                autoPlay={autoPlay}
                muted={muted}
                desktop={desktop_media}
                tablet={tablet_media}
                mobile={mobile_media}
            />
        `</Container>
    );
};

export default withRouter(VideoHeroWidget);
